export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}
export interface SortParams {
  sortBy: string;
  sortDirection: SortDirection;
}